import { Observable } from 'rxjs';
import { TranslationService } from './translation.service';
import { TranslationLanguage } from '@core/translation/translation-models';

export function translationInitializer(defaultLanguage: TranslationLanguage,
                                       translationService: TranslationService): Observable<boolean> {
    return translationService.init(defaultLanguage);
}
